var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-tabs',{attrs:{"value":0,"grow":""}},[_c('v-tab',[_vm._v("ABR-UBA")])],1),_c('v-tabs-items',{attrs:{"value":0}},[_c('v-tab-item',[_vm._t("default")],2)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }